module.exports = __webpack_public_path__ + "static/checkbox-3-52019a83778d1ea1cc3f28db10f61aa6.png";